/* eslint no-magic-numbers:0 */
import React, { Component } from 'react';

const throttle = (fn, wait) => {
	let time = Date.now();
	return () => {
		const newTime = time + wait;
		if (newTime - Date.now() < 0) {
			fn();
			time = Date.now();
		}
	};
};

export const breakpoints = {
	xs: [0, 599],
	sm: [600, 959],
	md: [960, 1279],
	lg: [1280, 1919],
	xl: [1920, Infinity],
};

const calculateBreakPoint = (width) =>
	Object.keys(breakpoints).reduce((prevValue, currentValue) => {
		const breakpoint = breakpoints[currentValue];
		if (width >= breakpoint[0] && width <= breakpoint[1]) {
			return currentValue;
		}
		return prevValue;
	}, 'xs');

export const WithBreakpoints = (WrappedComponent) =>
	class WithBreakpoints extends Component {
		constructor(props) {
			super(props);
			this.handleResize = this.handleResize.bind(this);

			window.addEventListener('resize', throttle(this.handleResize, 500));
			this.state = {
				breakpoint: calculateBreakPoint(window.innerWidth),
				width: window.innerWidth,
			};
		}
		componentWillUnmount() {
			window.removeEventListener('resize', this.handleResize);
		}

		handleResize() {
			this.setState({
				breakpoint: calculateBreakPoint(window.innerWidth),
			});
		}

		render() {
			return <WrappedComponent breakpoints={breakpoints} {...this.state} {...this.props} />;
		}
	};
